import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { lmsSourcesApi } from '@/features/admin/api/lmsSources.api'

const LMS_SOURCES_KEY = ['admin', 'lms-sources']

export function useLmsSourcesQuery() {
  return useQuery({
    queryKey: LMS_SOURCES_KEY,
    queryFn: lmsSourcesApi.list,
  })
}

export function useCreateLmsSource() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: lmsSourcesApi.create,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: LMS_SOURCES_KEY }),
  })
}

export function useSetLmsSourceActive() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, active }: { id: number; active: boolean }) =>
      active ? lmsSourcesApi.activate(id) : lmsSourcesApi.deactivate(id),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: LMS_SOURCES_KEY }),
  })
}

export function useRegenerateLmsSourceSecret() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => lmsSourcesApi.regenerateSecret(id),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: LMS_SOURCES_KEY }),
  })
}
